"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheCheckbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _core = require("../core");

var _utils = require("../utils");

var _checkbox = require("./checkbox.style");

var _excluded = ["indeterminate", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Checkboxes allow the user to select one or more items from a set
 */
var RocheCheckbox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var indeterminate = props.indeterminate,
      classes = props.classes,
      rest = _objectWithoutProperties(props, _excluded);

  var innerClasses = (0, _utils.mergeClasses)((0, _checkbox.useStyles)(), classes);
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
    ref: ref,
    classes: innerClasses,
    indeterminate: rest.checked && indeterminate
  }, rest));
});

exports.RocheCheckbox = RocheCheckbox;
RocheCheckbox.displayName = (0, _core.rochePrefix)('Checkbox');
RocheCheckbox.defaultProps = {
  color: 'primary'
};
var _default = RocheCheckbox;
exports["default"] = _default;